import {
  AddOptionModalComponent,
  ModalComponent,
  ResultsCircleComponent,
  ResultsEditSearchComponent,
  TooltipComponent,
  formlyComponents,
  formlyConfigOptions,
} from './components';
import {
  AffordabilityFormComponent,
  PersonalDetailsComponent,
  ResultsComponent,
} from './pages';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { ConfigService } from './services';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  CurrencyMaskDirective,
  GreaterThanValidatorDirective,
  InterestOnlyAmountValidatorDirective,
  MaxLtvValidatorDirective,
  MinPropertyValueValidatorDirective,
  MortgageTermValidatorDirective,
} from './components/forms/directives';

@NgModule({
  imports: [
    AppComponent,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FormlyModule.forRoot(formlyConfigOptions),
    FormlyBootstrapModule,
    // Pages
    AffordabilityFormComponent,
    ResultsComponent,
    PersonalDetailsComponent,
    // Components
    AddOptionModalComponent,
    ModalComponent,
    ResultsCircleComponent,
    ResultsEditSearchComponent,
    TooltipComponent,
    ...formlyComponents,
    // Directives
    CurrencyMaskDirective,
    GreaterThanValidatorDirective,
    InterestOnlyAmountValidatorDirective,
    MaxLtvValidatorDirective,
    MinPropertyValueValidatorDirective,
    MortgageTermValidatorDirective,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = ((configService: ConfigService) => () => configService.load())(inject(ConfigService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AppModule { }
